import { inject } from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import { EventService } from '../services/event.service';
import {first, map} from "rxjs/operators";

export const ConstituentAddressBooksResolver: ResolveFn<any> = ( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) : Observable<any>|Promise<any>|any => {

    const eventService = inject(EventService);

    return eventService.getConstituentAddressBook()
        .pipe(map(res => res.IndividualConstituent[0].constituentAddressBooks)
        ,first());
}
